<template>
    <div class="schedule-form">
        <div class="">
            <div class="heading">
                <h4 class="heading-title" v-if="location">
                    <input type="text" class="form-control font-18 font-weight-700" v-model="location.name" :placeholder="$t('location')">
                </h4>
                <h4 class="heading-title" v-if="user">
                    <strong>{{ user.name }}</strong>
                </h4>
            </div>

            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>{{ $t('module_name') }}</th>
                        <th colspan="2">{{ $t('from_until')}}</th>
                        <th v-if="trainers">{{ $t('trainer')}}</th>
                        <th v-if="locations">{{ $t('location')}}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <event v-for="(event, index) in events" :key="index"
                        :init-object="event"
                        :locations="locations"
                        @destroy="deleteEvent"
                    ></event>
                </tbody>
            </table>
        </div>

        <div class="">
            <button type="button" class="btn btn-theme-colored" @click="create" :disabled="disableSave">
                <i class="fa fa-plus"></i>
                {{ $t('new_event') }}
            </button>

            <button type="submit" class="btn btn-theme-colored2 pull-right" @click="save">
                <i class="fa fa-save"></i>
                {{ $t('save') }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            initEvents: Array,
            location: Object,
            user: Object,
            trainers: Object,
            locations: Object,
            method: String,
            route: String,
        },
        data: function () {
            return {
                events: this.initEvents,
                disableSave: false,
            }
        },
        methods: {
            create: function () {
                this.events.push({
                    name: '',
                    from: '',
                    until: '',
                    users: [],
                })
            },
            save: function () {
                var data = {
                    location: this.location,
                    events: this.events,
                }
                this.disableSave = true;

                if (this.method == 'post') {
                    axios.post(this.route, data).then(function (response) {
                        window.location.href = response.data;
                    });
                } else {
                    axios.patch(this.route, data).then(function (response) {
                        window.location.href = response.data;
                    });
                }
            },
            deleteEvent: function (event) {
                this.events.splice(this.events.indexOf(event), 1);
            },
        },
        created: function () {
            var trainers = [];

            for (var id in this.trainers) {
                trainers.push({
                    id: id,
                    name: this.trainers[id],
                })
            }

            this.$store.commit('SET_TRAINERS', trainers);
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/schedule/Schedule.vue